export const TYPES = {
  center: "tooltip--center-view",
  left: "tooltip--left-view",
  leftSticky: "tooltip--left-sticky-view",
  centerSticky: "tooltip--center-sticky-view",
};
